import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { CloudFooter } from 'assets/svg'
import { MQTT_COMMAND } from 'constants/appConstants'
import { useMqttClient } from 'hooks/useMqttClient'

import * as S from './styled'

const BaseLayout = ({ content: featuredVideo, setContentTime = () => {}, ...rest }) => {
  const { mqttClient } = useMqttClient()
  const [videoState, setVideoState] = useState()
  const [videoDuration, setVideoDuration] = useState()

  const getVideoDuration = duration => {
    setVideoDuration(duration * 1000)
  }
  const source = featuredVideo.video?.url
  const type = featuredVideo.video?.mime

  const updateVideoState = (topic, mqttMessage) => {
    const objectMessage = JSON.parse(mqttMessage.toString())
    if (objectMessage.data?.contentType !== 'featured-videos') {
      return
    }

    const { command, data } = objectMessage
    if (command === MQTT_COMMAND.PLAY || command === MQTT_COMMAND.PAUSE) {
      setVideoState({ command, time: data.currentTime })
    }
  }

  useEffect(() => {
    if (videoDuration) {
      setContentTime(videoDuration)
      setVideoState({ command: null, time: 0 })
    }
  }, [videoDuration])

  useEffect(() => {
    if (!mqttClient) {
      return
    }

    mqttClient.on('message', updateVideoState)
    if (mqttClient.lastMessage) {
      updateVideoState(null, mqttClient.lastMessage)
    }

    return () => mqttClient.removeListener('message', updateVideoState)
  }, [mqttClient])

  return (
    <S.Container {...rest}>
      <S.Video
        source={source}
        type={type}
        loop={false}
        muted={true}
        state={videoState}
        getVideoDuration={getVideoDuration}
      />
      <S.Description>
        <p>{featuredVideo.description}</p>
      </S.Description>
      <S.Container>
        <CloudFooter className='cloud'></CloudFooter>
      </S.Container>
    </S.Container>
  )
}

BaseLayout.defaultProps = {
  content: {},
}

BaseLayout.propTypes = {
  content: PropTypes.object,
  setContentTime: PropTypes.func,
}

export default BaseLayout
